// @ts-check


/**
 * @type  { ({key: string, question: string, answer: *})[] }
 */
export const consultInitData = [
    {
      "key": "info_name",
      "question" : "1. 기초사항 - 성함",
      "answer": ""
    },
    {
      "key": "info_tel",
      "question" : "1. 기초사항 - 의뢰인의 연락처",
      "answer": ""
    },
    {
      "key": "info_case",
      "question" : "1. 기초사항 - 사건명",
      "answer": ""
    },
    {
      "key": "detail_occurred",
      "question" : "2. 사건 발생 경위",
      "answer": ""
    },
    {
      "key": "evidence",
      "question": "3. 사건 관련 자료",
      "answer": [{
        "case" : "",
        "content" : "",
        "obtain" : "",
      }]
    },
    {
      "key": "evidence_file",
      "question": "3. 사건 관련 자료 파일",
      "answer":[""]
    },
    {
      "key": "investigation",
      "question": "4. 수사기관 조사 내용",
      "answer": [{
        "date" : "",
        "agency" : "",
        "content" : "",
        "evidence" : "",
      }]
    },
    {
      "key": "investigation_file",
      "question": "4. 수사기관 조사 내용 파일",
      "answer":[""]
    },
    {
      "key": "current_situation",
      "question" : "5. 현재 상황 및 변호인에 대한 요청 사항",
      "answer": ""
    },
    {
      "key": "etc",
      "question" : "6. 기타 자유기재",
      "answer": ""
    },
]

// // 참고용 코드로 주석으로 남겨둠. 
// let consultMap = new Map()

// consultMap.set('sheet_couple_net_property', 
// {
//   "key": "sheet_couple_net_property",
//   "question" : "재산명세표 - 부부 순재산의 합계(원)",
//   "answer": "0"
// })

// const consultArrToMap = () => {
//   consultMap = consultInitData.reduce((map, item) => {
//     return map.set(item.key, item)
//   }, new Map())

//   console.info(consultMap)
// }

// consultArrToMap()